import {Toaster} from "@/components/ui/toaster";
import {Toaster as Sonner} from "@/components/ui/sonner";
import {TooltipProvider} from "@/components/ui/tooltip";
import {Routes, Route} from "react-router-dom";
import Index from "./pages/Index";
import AboutUs from "./pages/AboutUs";
import OurTeam from "./pages/OurTeam";
import PortfolioPage from "./pages/PortfolioPage";
import ProjectDetails from "./pages/ProjectDetails";
import ContactUs from "./pages/ContactUs";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import {ScrollProvider} from "./contexts/ScrollContext";
import {APIProvider} from '@vis.gl/react-google-maps';

const App = () => {
    return (
        <APIProvider apiKey={'AIzaSyDbB6vX10HWJmR-vjRfYOd0K5eL3OBC1A4'}>
            <div className="w-full max-w-full overflow-x-hidden">
                <ScrollProvider>
                    <TooltipProvider>
                        <ScrollToTop/>
                        <Toaster/>
                        <Sonner/>
                        <Routes>
                            <Route path="/" element={<Index/>}/>
                            <Route path="/about" element={<AboutUs/>}/>
                            <Route path="/team" element={<OurTeam/>}/>
                            <Route path="/portfolio" element={<PortfolioPage/>}/>
                            <Route path="/project/:projectId" element={<ProjectDetails/>}/>
                            <Route path="/contact" element={<ContactUs/>}/>
                            {/* Use NotFound component for 404 routes */}
                            <Route path="*" element={<NotFound/>}/>
                        </Routes>
                    </TooltipProvider>
                </ScrollProvider>
            </div>
        </APIProvider>
    );
};

export default App;
